module.exports = __webpack_public_path__ + "img/bg_more_video.1beea669.png";